var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 4.813H16.5v-.688a1.376 1.376 0 0 0-1.375-1.375h-8.25A1.377 1.377 0 0 0 5.5 4.125v.688H4.125A1.377 1.377 0 0 0 2.75 6.188V8.25A2.753 2.753 0 0 0 5.5 11h.221a5.616 5.616 0 0 0 4.591 4.08v2.795H6.876v1.375h8.25v-1.375h-3.438v-2.797A5.476 5.476 0 0 0 16.322 11h.179a2.753 2.753 0 0 0 2.75-2.75V6.187a1.376 1.376 0 0 0-1.375-1.375zM5.5 9.625A1.377 1.377 0 0 1 4.125 8.25V6.187H5.5v3.438zm9.625 0a4.126 4.126 0 0 1-4.252 4.123 4.262 4.262 0 0 1-3.998-4.325V4.125h8.25v5.5zm2.75-1.375A1.376 1.376 0 0 1 16.5 9.625V6.187h1.375V8.25z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyManagementIcon);
export default __webpack_public_path__ + "static/media/loyaltyManagementIcon.6e218082265b2419b112fdb3c8b74c6c.svg";
export { ForwardRef as ReactComponent };